var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPenOrange = function SvgIconPenOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "m1.66 8.828 2.21-.442a.4.4 0 0 0 .213-.114l2.771-2.77a.417.417 0 0 0 0-.59L5.086 3.144a.417.417 0 0 0-.589 0l-2.77 2.771a.4.4 0 0 0-.115.213l-.442 2.21a.417.417 0 0 0 .49.49M8.414 2.174l-.59-.59a1.25 1.25 0 0 0-1.767 0l-.411.411a.417.417 0 0 0 0 .59l1.768 1.767a.417.417 0 0 0 .589 0l.41-.41a1.25 1.25 0 0 0 0-1.768"
  })));
};
export default SvgIconPenOrange;